const ArrowStraight = require('./lib/ArrowStraight.js').default;

module.exports.ArrowStraight = ArrowStraight;
